var $ = jQuery;

export function init () {
  function parallaxIt() {

    // create variables
    var $fwindow = $(window);
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // on window scroll event
    $fwindow.on('scroll resize', function() {
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    });

    // for each of content parallax element
    $('[data-type="content"]').each(function (index, e) {
      var $contentObj = $(this);
      var fgOffset = parseInt($contentObj.offset().top);
      var yPos;
      var speed = ($contentObj.data('speed') || 1 );

      $fwindow.on('scroll resize', function() {
        fgOffset = parseInt($contentObj.offset().top);
        yPos = (fgOffset - scrollTop + 100) / speed;
        $contentObj.css('top', yPos);
      });
    });

    // for each of background parallax element
    $('[data-type="background"]').each(function() {
      var $backgroundObj = $(this);
      var bgOffset = parseInt($backgroundObj.offset().top);
      var yPos;
      var transProp;
      var speed = ($backgroundObj.data('speed') || 0 );

      $fwindow.on('scroll resize', function() {
        bgOffset = parseInt($backgroundObj.offset().top);
        yPos = ((scrollTop - bgOffset + 100) / speed);
        transProp = 'translateY(' + yPos + 'px)';

        $backgroundObj.css('transform', transProp);
      });
    });

    // triggers window scroll for refresh
    $fwindow.trigger('scroll');
  }

  parallaxIt();

}
